export default __webpack_public_path__ + "static/media/pres_indetail_illusHeader_tall375.aa6a70c3.png";